import { FundStrategyExportExcelData, RoundsFS } from "../models/fund-strategy/pojo/fund-strategy-export-classes";
import * as XLSX from 'xlsx-js-style';

export enum ExcelTemplateName {
  fundStrategyInternal,
  fundStrategyExternal,
}

export type ExcelData =
  RoundsFS[] |
  FundStrategyExportExcelData

export interface ExcelOptions {
  isAdmin?: boolean;
  soiEntireOrg?: boolean;
  isQuarterlyGl?: boolean;
}

export interface ExcelTemplate {
  /**
   * Main method that exports data to Excel format.
   */
  export(data: ExcelData, options: ExcelOptions): XLSX.WorkBook;
}

export type Row = unknown[];
export type Rows = Row[];
